import { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { track } from "@/lib/analytics";

/**
 * StickyBookButton — always-visible "Book Now" CTA.
 *
 * Desktop: small pill floating bottom-right.
 * Mobile: full-width bottom bar with price anchor.
 *
 * Only appears AFTER the user has scrolled past the hero (500px), so it
 * doesn't compete with the primary hero CTA on first load.
 */
export default function StickyBookButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToBooking = () => {
    track("sticky_book_click");
    const el = document.getElementById("booking");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  if (!visible) return null;

  return (
    <>
      {/* Mobile bottom bar */}
      <div
        className="fixed bottom-0 left-0 right-0 z-40 sm:hidden pb-safe"
        data-testid="sticky-book-mobile"
      >
        <button
          onClick={scrollToBooking}
          className="w-full flex items-center justify-between gap-3 px-5 py-4 bg-[#E30613] text-white font-medium text-base shadow-2xl shadow-black/50 active:scale-[0.98] transition-transform"
        >
          <span className="flex items-center gap-2">
            <Zap className="w-4 h-4" />
            Book Now
          </span>
          <span className="text-xs font-normal opacity-80">
            From $150 · 60 sec
          </span>
        </button>
      </div>

      {/* Desktop floating pill */}
      <button
        onClick={scrollToBooking}
        className="hidden sm:flex fixed bottom-6 right-6 z-40 items-center gap-2 pl-4 pr-5 py-3.5 bg-[#E30613] hover:bg-[#c1050f] text-white font-medium rounded-full shadow-2xl shadow-[#E30613]/40 active:scale-95 transition-all group"
        data-testid="sticky-book-desktop"
      >
        <Zap className="w-4 h-4 group-hover:animate-pulse" />
        Book Now
        <span className="hidden md:inline text-xs font-normal opacity-80 border-l border-white/30 pl-2 ml-1">
          From $150
        </span>
      </button>
    </>
  );
}
